module.exports = __webpack_public_path__ + "img/video_ready.86c4497c.png";